var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"my-5 mx-3"},[_vm._v(_vm._s(_vm.$t("notFoundTitle")))]),_c('p',{staticClass:"my-3 mx-3 title font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("notFoundDescription"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }